export default __webpack_public_path__ + "static/media/icon-library.8315f4f4.svg";